// contentFeedGetters.js — selectors for the contentFeed Redux branch
export const getContentFeedItems = (state) => state.contentFeed?.items || [];
export const getContentFeedGeneratedAt = (state) => state.contentFeed?.generatedAt || null;
export const getContentFeedTotalItems = (state) => state.contentFeed?.totalItems || 0;
export const getContentFeedNextToken = (state) => state.contentFeed?.nextToken || null;
export const getContentFeedSearchResults = (state) => state.contentFeed?.searchResults ?? null;
export const getContentFeedRefreshStatus = (state) => state.contentFeed?.refreshStatus || null;
export const getContentFeedLoading = (state) => state.contentFeed?.loading || false;
export const getContentFeedSearching = (state) => state.contentFeed?.searching || false;
export const getContentFeedError = (state) => state.contentFeed?.error || null;
